// extracted by mini-css-extract-plugin
module.exports = {"page":"style__page__pa2IK"};